/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AvailableYearsResponse } from '../models/AvailableYearsResponse';
import type { CompareAcademyUpdateRequest } from '../models/CompareAcademyUpdateRequest';
import type { CompareResponse } from '../models/CompareResponse';
import type { DepartmentListResponse } from '../models/DepartmentListResponse';
import type { DeptInfoExcelGenerateRequest } from '../models/DeptInfoExcelGenerateRequest';
import type { DeptInfoExcelImportResponse } from '../models/DeptInfoExcelImportResponse';
import type { HiddenIndicatorUpdateRequest } from '../models/HiddenIndicatorUpdateRequest';
import type { HiddenIndicatorUpdateResponse } from '../models/HiddenIndicatorUpdateResponse';
import type { IndicatorMasterItem } from '../models/IndicatorMasterItem';
import type { InfoExcelGenerateRequest } from '../models/InfoExcelGenerateRequest';
import type { InfoExcelImportResponse } from '../models/InfoExcelImportResponse';
import type { OrgAcademySettingResponse } from '../models/OrgAcademySettingResponse';
import type { PaginatedResponse_AcademyListItem_ } from '../models/PaginatedResponse_AcademyListItem_';
import type { TrendsResponse } from '../models/TrendsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AcademyinfoService {
    /**
     * List Academies
     * 대학 목록 조회
     * @returns PaginatedResponse_AcademyListItem_ OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsListAcademies({
        search,
        schoolType,
        establishmentType,
        region,
        page = 1,
        perPage = 20,
    }: {
        search?: (string | null),
        schoolType?: (string | null),
        establishmentType?: (string | null),
        region?: (string | null),
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_AcademyListItem_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/academyinfo/academies',
            query: {
                'search': search,
                'school_type': schoolType,
                'establishment_type': establishmentType,
                'region': region,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Compare Academies
     * 학교 비교 데이터 조회
     * @returns CompareResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsCompareAcademies({
        academyIds,
        surveyYear,
        orgId,
        indicatorCodes,
    }: {
        academyIds: string,
        surveyYear: string,
        orgId: string,
        indicatorCodes?: (string | null),
    }): CancelablePromise<CompareResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/academyinfo/compare',
            query: {
                'academy_ids': academyIds,
                'survey_year': surveyYear,
                'org_id': orgId,
                'indicator_codes': indicatorCodes,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Get Trends
     * 연도별 추이 조회
     * @returns TrendsResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsGetTrends({
        academyIds,
        indicatorMasterId,
        orgId,
        years,
        region,
    }: {
        academyIds: string,
        indicatorMasterId: string,
        orgId: string,
        years?: (string | null),
        region?: (string | null),
    }): CancelablePromise<TrendsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/academyinfo/trends',
            query: {
                'academy_ids': academyIds,
                'indicator_master_id': indicatorMasterId,
                'org_id': orgId,
                'years': years,
                'region': region,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Get Org Setting
     * 기관의 내 학교 + 비교학교 설정 조회
     * @returns OrgAcademySettingResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsGetOrgSetting({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<OrgAcademySettingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/academyinfo/org-setting',
            query: {
                'org_id': orgId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Compare Academies
     * 비교학교 설정 변경 (기관 관리자)
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgAcademySettingResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsUpdateCompareAcademies({
        orgId,
        requestBody,
    }: {
        orgId: string,
        requestBody: CompareAcademyUpdateRequest,
    }): CancelablePromise<OrgAcademySettingResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/academyinfo/org-setting',
            query: {
                'org_id': orgId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Hidden Indicators
     * 기관별 숨김 공시항목 설정 (기관 관리자).
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns HiddenIndicatorUpdateResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsUpdateHiddenIndicators({
        orgId,
        requestBody,
    }: {
        orgId: string,
        requestBody: HiddenIndicatorUpdateRequest,
    }): CancelablePromise<HiddenIndicatorUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/academyinfo/org-setting/hidden-indicators',
            query: {
                'org_id': orgId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * List Indicators
     * 공시항목 마스터 목록 조회. include_hidden=true는 기관 관리자 전용(전체+hidden 플래그).
     * @returns IndicatorMasterItem OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsListIndicators({
        orgId,
        includeHidden = false,
    }: {
        orgId: string,
        includeHidden?: boolean,
    }): CancelablePromise<Array<IndicatorMasterItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/academyinfo/indicators',
            query: {
                'org_id': orgId,
                'include_hidden': includeHidden,
            },
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Get Available Years
     * 수집된 공시년도 목록.
     *
     * org_id 가 주어지면 해당 기관의 hidden_years 를 제외한다.
     * 어드민이 hidden_years 관리 UI 등에서 전체 연도가 필요하면 org_id 없이 호출.
     * @returns AvailableYearsResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsGetAvailableYears({
        academyId,
        orgId,
    }: {
        academyId?: (string | null),
        orgId?: (string | null),
    }): CancelablePromise<AvailableYearsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/academyinfo/available-years',
            query: {
                'academy_id': academyId,
                'org_id': orgId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Departments
     * 학과별 자료 조회 (정보엑셀로 동기화된 학과 + 학과별 지표).
     *
     * survey_year 미지정 시 해당 대학의 최신 공시년도 지표를 반환한다.
     * @returns DepartmentListResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsListDepartments({
        academyId,
        surveyYear,
    }: {
        academyId: string,
        surveyYear?: (string | null),
    }): CancelablePromise<DepartmentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/academyinfo/departments',
            query: {
                'academy_id': academyId,
                'survey_year': surveyYear,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Sync Universities
     * 대학알리미에서 전체 대학 목록 동기화 (관리자)
     * @returns any OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsSyncUniversities(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/sync/universities',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Sync Indicators
     * 대학알리미에서 공시항목 마스터 동기화 (관리자)
     * @returns any OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsSyncIndicators(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/sync/indicators',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Generate Info Excel
     * 선택한 학교 + 연도 범위에 대한 정보 엑셀을 생성·다운로드 (관리자).
     *
     * 응답: xlsx 바이너리. 사람이 검토·수정 후 upload 엔드포인트로 재업로드해 DB 적재.
     * @returns void
     * @throws ApiError
     */
    public static appsAcademyinfoViewsGenerateInfoExcel({
        requestBody,
    }: {
        requestBody: InfoExcelGenerateRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/admin/info-excel/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Sync Info Excel
     * 누적 xlsx → 정보엑셀 생성 → DB 적재까지 한 번에 (사람 검토 생략).
     *
     * 4개 인프라 운영 시 git pull 후 어드민에서 버튼 하나로 동기화하는 자동 모드.
     * 수동 검토가 필요한 경우 generate → upload 흐름을 사용한다.
     * @returns InfoExcelImportResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsSyncInfoExcel({
        requestBody,
    }: {
        requestBody: InfoExcelGenerateRequest,
    }): CancelablePromise<InfoExcelImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/admin/info-excel/sync',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload Info Excel
     * 정보 엑셀 업로드 → AcademyIndicator 업서트 (관리자).
     *
     * 포맷: generate_info_excel과 동일. 시트명이 alimi_xxx인 시트만 처리한다.
     * 충돌 정책: 항상 업로드 값으로 덮어쓰기 (값 동일이면 unchanged).
     * @returns InfoExcelImportResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsUploadInfoExcel({
        formData,
    }: {
        formData: {
            file: Blob;
        },
    }): CancelablePromise<InfoExcelImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/admin/info-excel/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Generate Dept Info Excel
     * 선택한 학교의 학과별 정보엑셀 생성·다운로드 (관리자, 학교당 1파일).
     * @returns void
     * @throws ApiError
     */
    public static appsAcademyinfoViewsGenerateDeptInfoExcel({
        requestBody,
    }: {
        requestBody: DeptInfoExcelGenerateRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/admin/dept-info-excel/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload Dept Info Excel
     * 학과 정보엑셀 업로드 → AcademyDepartmentIndicator 업서트 (관리자).
     * @returns DeptInfoExcelImportResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsUploadDeptInfoExcel({
        formData,
    }: {
        formData: {
            file: Blob;
        },
    }): CancelablePromise<DeptInfoExcelImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/admin/dept-info-excel/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Sync Dept Info Excel
     * 학과별 자동 적재: 누적 xlsx → 정보엑셀 생성 → DB 업서트까지 한 번에 (관리자).
     *
     * 4개 인프라에서 git pull 후 버튼 하나로 학과별 지표 동기화.
     * @returns DeptInfoExcelImportResponse OK
     * @throws ApiError
     */
    public static appsAcademyinfoViewsSyncDeptInfoExcel({
        requestBody,
    }: {
        requestBody: DeptInfoExcelGenerateRequest,
    }): CancelablePromise<DeptInfoExcelImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/academyinfo/admin/dept-info-excel/sync',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
